export default "__VITE_ASSET__f66d7b08__"